<script setup lang="ts">
const props = defineProps({ blok: Object })

const data = [
    {
        number: props.blok?.data_1_number,
        description: props.blok?.data_1_description,
    },
    {
        number: props.blok?.data_2_number,
        description: props.blok?.data_2_description,
    },
    {
        number: props.blok?.data_3_number,
        description: props.blok?.data_3_description,
    },
]
</script>

<template>
    <section class="py-20 bg-chsc-yellow">
        <UiContainer>
            <div class="grid grid-cols-2 max-[769px]:grid-cols-1 max-[769px]:gap-y-10">
                <header
                    class="insight-category-header"
                    style="text-align: left;"
                >
                    <img
                        :src="blok?.icon.filename"
                        :alt="blok?.icon.alt"
                        style="margin-left: 0;"
                    >
                    <StoryblokRichText :doc="blok?.header" />
                </header>
                <div class="flex flex-col items-center justify-center max-[769px]:flex-row">
                    <img
                        v-motion-slide-visible-once-top
                        :src="blok?.image1.filename"
                        :alt="blok?.image1.alt"
                    >
                    <img
                        v-motion-slide-visible-once-top
                        :src="blok?.image2.filename"
                        :alt="blok?.image2.alt"
                        class="-mt-44 max-[769px]:mt-0"
                    >
                    <img
                        v-motion-slide-visible-once-top
                        :src="blok?.image3.filename"
                        :alt="blok?.image3.alt"
                        class="-mt-44 max-[769px]:mt-0"
                    >
                </div>
            </div>
        </UiContainer>
        <UiContainer>
            <div
                v-motion-slide-visible-once-bottom
                class="relative mt-20 border-[2px] border-chsc-indigo-500 rounded-[40px] p-12"
            >
                <h4 class="absolute top-0 left-12 -translate-y-1/2 bg-chsc-yellow px-4 fs-4xl font-londrina-solid text-chsc-indigo-500 mb-6">
                    {{ blok?.data_title }}
                </h4>
                <div class="grid grid-cols-3 gap-x-20 [&>div>p]:font-londrina-solid [&>div>p]:fs-4xl [&>div>p]:text-center max-[641px]:grid-cols-1 max-[641px]:gap-x-0 max-[641px]:gap-y-6">
                    <div
                        v-for="item in data"
                        :key="item.number"
                    >
                        <p class="fs-8xl text-white">
                            {{ item.number }}%
                        </p>
                        <p class="fs-2xl text-chsc-indigo-500">
                            {{ item.description }}
                        </p>
                    </div>
                </div>
            </div>
        </UiContainer>
        <UiContainer>
            <div class="mt-20 flex gap-x-20 items-center max-[769px]:flex-col max-[769px]:gap-y-0">
                <div class="w-2/3 [&>h4]:font-londrina-solid [&>h4]:fs-4xl [&>h4]:text-chsc-indigo-500 [&>h4]:mb-6 [&>p]:fs-2xl  [&>p]:mb-6 [&>p]:last:mb-0 [&>p]:font-eb-garamond [&>h5]:font-londrina-solid [&>h5]:fs-4xl [&>h5]:text-chsc-indigo-500 [&>h5]:mb-6 [&>h6]:font-londrina-solid [&>h6]:fs-4xl [&>h6]:text-chsc-indigo-500 [&>h6]:mb-6 max-[769px]:w-full">
                    <StoryblokRichText :doc="blok?.uk_data" />
                </div>
                <div class="w-1/3 max-[769px]:w-full">
                    <div
                        v-motion-slide-visible-once-bottom
                        class="relative mt-20 border-[2px] border-chsc-indigo-500 rounded-[40px] p-12"
                    >
                        <h4 class="absolute top-0 left-12 -translate-y-1/2 bg-chsc-yellow px-4 fs-4xl font-londrina-solid text-chsc-indigo-500 mb-6">
                            {{ blok?.supply_chain_title }}
                        </h4>
                        <div class="[&>div>p]:font-londrina-solid [&>div>p]:fs-4xl [&>div>p]:text-center [&>div>p]:mb-6 [&>div>p]:last:mb-0 [&>div>p]:text-chsc-indigo-500 [&>div>p>strong]:fs-9xl [&>div>p>strong]:font-normal">
                            <div>
                                <StoryblokRichText :doc="blok?.supply_chain_description" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
